export default __webpack_public_path__ + "static/media/dementia.3d82e51e.png";